import React, { useEffect, useState, useMemo, useRef } from "react";
import useStyles from "./Styles";
import L from "leaflet";
import "leaflet.pattern";
import "leaflet/dist/leaflet.css";
import centralAZMap from "../../assets/Central_Arizona.json";
import industryMap from "../../assets/Water_User_Industry.json";
import { Slider, Box, Tooltip } from "@material-ui/core";
// import { usePrevious } from "components/common/usePrevious";
import ReactDOM from "react-dom";
import { useSelector } from "react-redux";
import { createMuiTheme, ThemeProvider } from "@material-ui/core/styles";
import { calculateLegendLabels } from "./utils";
import useGetViewPortDimensions from "hooks/useGetViewPortDimensions";

var map;
var allModelLayer;
var industryLayer;
var legendAllData;
var legendLabel = [0, 0, 0, 0, 0, 0, 0];
var stripes;

const theme = createMuiTheme({
  direction: "rtl",
});

const tribesList = {
  "San Carlos Apache Tribe": true,
  "Fort McDowell Indian Community": true,
  "Salt River Pima-Maricopa Indian Community": true,
  "Gila River Indian Community": true,
  "Ak-Chin Indian Community": true,
  "Tohono O'odham Nation": true,
  "Pascua Yaqui Tribe": true,
  "Camp Verde (Yavapai-Apache)": true,
  "Tonto Apache Tribe": true,
};

const agricultureList = {
  "New Magma Irrigation and Drainage District": true,
  "Roosevelt Irrigation District": true,
  "Roosevelt Water Conservation District": true,
  "Central Arizona Irrigation and Drainage District": true,
  "Maricopa Water District": true,
  "Queen Creek Irrigation Water Delivery District": true,
  "Hohokam Irrigation and Drainage District": true,
  "Maricopa-Stanfield Irrigation and Drainage District": true,
  "Cortaro-Marana Water Users Association": true,
  "San Carlos Irrigation and Drainage District": true,
  "Tonopah Irrigation District": true,
  "Salt River Valley Water Users Association": true,
  "Buckeye Water Conservation and Drainage District": true,
  "Mohave Valley Irrigation and Drainage District": true,
  "Mohave Water Conservation District": true,
  "Cibola Valley Irrigation and Drainage District": true,
  "Wellton-Mohawk Irrigation and Drainage District": true,
  "Yuma Mesa Irrigation and Drainage District": true,
  "Yuma Irrigation and Drainage District": true,
  "North Gila Valley Irrigation and Drainage District": true,
  "Unit B Irrigation and Drainage District": true,
  "Hillander-C Irrigation and Drainage District": true,
  "Sturgest Gila Monster Ranch": true,
  "Yuma County Water Users Association": true,
  "Avra Valley Irrigation District": true,
};

const valueLabelFormat = (value) => {
  // Handles the case when the value has already been converted to the string format
  if (typeof value !== "number") {
    return value;
  }
  return `${value.toLocaleString("en-US")} acre-feet`;
};
const ValueLabelComponent = (props) => {
  const classes = useStyles();
  const { children, value } = props;
  const title = valueLabelFormat(value);
  return (
    <Tooltip
      placement="top"
      arrow
      title={title}
      open={true}
      classes={{
        tooltip: classes.centralTooltipPopper,
      }}
    >
      {children}
    </Tooltip>
  );
};

// const colorsCentralLegend = [
//   "#90EAF4",
//   "#83D1ED",
//   "#76B7E7",
//   "#699EE0",
//   "#4A72B5",
//   "#2B478A",
//   "#0C1B5F",
// ];
const colorsCentralLegend = [
  "#BDD0F8",
  "#7EA6F9",
  "#467BE8",
  "#225DD8",
  "#0C3588",
];

function getCentralColors(d) {
  return d >= legendLabel[4]
    ? colorsCentralLegend[4]
    : d >= legendLabel[3]
    ? colorsCentralLegend[3]
    : d >= legendLabel[2]
    ? colorsCentralLegend[2]
    : d >= legendLabel[1]
    ? colorsCentralLegend[1]
    : d >= legendLabel[0]
    ? colorsCentralLegend[0]
    : null;
}

function CentralArizonaMap() {
  const classes = useStyles();

  const containerRef = useRef(document.createElement("div"));
  const { toggle_about, scenario, entitlement_difference } = useSelector(
    (state) => state.central_arizona
  );
  // Will remove it after testing
  // const [selectedsrc/components/TechnicalView/AboutSidebar/AboutTogglebar.jsFeature, setSelectedFeature] = useState(null);
  // const previousFeature = usePrevious(selectedFeature);
  const [sliderValue, setSliderValue] = useState(100);
  const { isMobile } = useGetViewPortDimensions();

  // renders slider component
  const marks = [
    {
      value: 0,
      scaledValue: 800000,
      label: "Tier 3",
    },

    {
      value: 25,
      scaledValue: 850000,
      label: "Tier 2b",
    },

    {
      value: 50,
      scaledValue: 900000,
      label: "Tier 2a",
    },

    {
      value: 75,
      scaledValue: 1000000,
      label: "Tier 1",
    },
    {
      value: 100,
      scaledValue: 1300000,
      label: "Tier 0",
    },
  ];

  const marksSevere = [
    {
      value: 0,
      scaledValue: 300000,
      label: "300K",
    },

    {
      value: 25,
      scaledValue: 400000,
      label: "400K",
    },

    {
      value: 50,
      scaledValue: 500000,
      label: "500K",
    },

    {
      value: 75,
      scaledValue: 600000,
      label: "600K",
    },
    {
      value: 100,
      scaledValue: 700000,
      label: "700K",
    },
  ];

  const scale = (value) => {
    const previousMarkIndex = Math.floor(value / 25);
    const previousMark =
      scenario === "DCP Cuts"
        ? marks[previousMarkIndex]
        : marksSevere[previousMarkIndex];
    const remainder = value % 25;
    if (remainder === 0) {
      return previousMark.scaledValue;
    }
  };

  const handleSliderChange = (e, value) => {
    // console.log("i am the slider", sliderValue);
    setSliderValue(value);
  };

  const SliderComponent = () => {
    return (
      <Box className={classes.centralmapSliderContainer}>
        <ThemeProvider theme={theme}>
          <Slider
            // defaultValue={50}
            value={sliderValue}
            step={25}
            marks={scenario === "DCP Cuts" ? marks : marksSevere}
            scale={scale}
            min={0}
            max={100}
            classes={{
              root: classes.centralSlider,
              rail: classes.centralSliderRail,
              trackInverted: classes.centralSliderTrackInverted,
              track: classes.centralSliderTrack,
              thumb: classes.centralSliderThumb,
              mark: classes.centralSliderMark,
              markLabel: classes.centralMarkLabel,
            }}
            onChange={handleSliderChange}
            // track="inverted"
            valueLabelDisplay="on"
            getAriaValueText={valueLabelFormat}
            valueLabelFormat={valueLabelFormat}
            ValueLabelComponent={ValueLabelComponent}
          />
        </ThemeProvider>
      </Box>
    )
  }
  
  const widget = useMemo(SliderComponent,
    [scenario, sliderValue, toggle_about]
  );

  const onEachFeature = (feature, layer) => {
    let color;
    // when map first mounts
    if (!Object.keys(entitlement_difference).length) {
      if (agricultureList.hasOwnProperty(feature.properties.combined_4)) {
        layer.setStyle({
          fillColor: "#707070",
          fillOpacity: 0.6,
          weight: 1,
          color: "#707070",
          fillPattern: stripes,
        });
      } else {
        layer.setStyle({
          fillColor: "#699EE0",
          fillOpacity: 0.6,
          weight: 1,
          color: "#707070",
        });
      }
    }
    //use color function to get the name of the feature and find the legend color according to percentage difference
    if (Object.keys(entitlement_difference).length) {
      if (tribesList.hasOwnProperty(feature.properties.combine_14)) {
        // Handle tribes - will always have info
        if (scale(sliderValue) === 1300000 || scale(sliderValue) === 700000) {
          color = "#699EE0";
        } else {
          color = getCentralColors(
            entitlement_difference[scale(sliderValue)][
              feature.properties.combine_14
            ]
          );
        }
        layer.setStyle({
          fillColor: color,
          fillOpacity: 0.6,
          weight: 1,
          color: "#707070",
        });
        layer.bindTooltip(feature.properties.combine_14, {
          direction: "top",
        });
      } else if (
        // handles cities
        entitlement_difference[scale(sliderValue)].hasOwnProperty(
          feature.properties.combined_4
        )
      ) {
        if (scale(sliderValue) === 1300000 || scale(sliderValue) === 700000) {
          color = "#699EE0";
        } else {
          color = getCentralColors(
            entitlement_difference[scale(sliderValue)][
              feature.properties.combined_4
            ]
          );
        }
        layer.setStyle({
          fillColor: color,
          fillOpacity: 0.6,
          weight: 1,
          color: "#707070",
        });
        layer.bindTooltip(feature.properties.combined_4, {
          direction: "top",
        });
      } else {
        layer.setStyle({
          fillColor: "#707070",
          fillOpacity: 0.6,
          weight: 1,
          color: "#707070",
          fillPattern: stripes,
        });
        layer.bindTooltip(feature.properties.combined_4, {
          direction: "top",
        });
      }
    }
  };

  const pointToLayer = (feature, latlng) => {
    let color = "#699EE0";
    // If slider is 1300000 or 700000 just use #699EE0
    if (
      Object.keys(entitlement_difference).length &&
      scale(sliderValue) !== 1300000 &&
      scale(sliderValue) !== 700000
    ) {
      color = getCentralColors(
        entitlement_difference[scale(sliderValue)][
          feature.properties.company_name
        ]
      );
      // console.log(`${feature.properties.company_name} color is ${color}`);
    }

    const circle = L.circleMarker(latlng, {
      radius: 9,
      fillColor: color,
      weight: 1,
      fillOpacity: 0.6,
      color: "#707070",
    }).bindTooltip(feature.properties.company_name, {
      direction: "top",
      offset: L.point({ x: 0, y: -9 }),
    });
    // .openTooltip();
    return circle;
  };

  useEffect(() => {
    if (map) {
      map.remove();
    }
    map = L.map("map", {
      center: new L.LatLngBounds(
        new L.LatLng(31.9, -113),
        new L.LatLng(35.2, -111.2)
      ).getCenter(),
      zoomControl: false,
      doubleClickZoom: true,
      scrollWheelZoom: true,
      zoom: 8,
      maxZoom: 17,
      // maxZoom: 11,
      minZoom: 5,
      maxBounds: [
        //south-west coordinates
        // [32, -113],
        [30, -115],
        //north-east coordinates
        // [35, -111.0]
        [37.5, -108.0],
      ],
      maxBoundsViscosity: 1.0,
      layers: [
        L.tileLayer(
          "https://{s}.basemaps.cartocdn.com/rastertiles/voyager_labels_under/{z}/{x}/{y}{r}.png",
          {
            noWrap: true,
            attribution:
              '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors &copy; <a href="https://carto.com/attributions">CARTO</a>',
            subdomains: "abcd",
          }
        ),
      ],
    });
    // add zoom control
    L.control
      .zoom({
        position: "topright",
      })
      .addTo(map);
  }, [toggle_about]);

  useEffect(() => {
    stripes = new L.StripePattern({
      // height: 10,
      // width: 10,
      // color: '#076f00',
      color: "black",
      // spaceColor: '#27d71b',
      spaceColor: "white",
      weight: 5,
      spaceWeight: 10,
      angle: 135,
      // opacity: 0.55,
      // spaceOpacity: 0.45,
      spaceOpacity: 1,
      opacity: 0.5,
    }).addTo(map);
  }, [toggle_about, scenario]);

  const createDOM = () => {
    if (legendAllData) {
      legendAllData.remove();
    }
    legendAllData = L.control({
      position: isMobile ? "topleft" : "bottomright",
    });
    legendLabel = calculateLegendLabels(scale(sliderValue), scenario);
    // console.log("i am label", legendLabel);
    // console.log("i am sliderlegend", scale(sliderValue));
    legendAllData.onAdd = function (map) {
      var div = L.DomUtil.create("div", "info legend");
      div.innerHTML += `<div style="padding: 3px 0px 3px 0px" class='legendTitle'> % change </div>`;
      div.innerHTML += `<div class ='legendContent'><i style="background:${colorsCentralLegend[0]}"></i>+${legendLabel[0]}%</div><br/>`;
      div.innerHTML += `<div class ='legendContent'><i style="background:${colorsCentralLegend[1]}"></i>+${legendLabel[1]}%</div><br/>`;
      div.innerHTML += `<div class ='legendContent'><i style="background:${colorsCentralLegend[2]}"></i>+${legendLabel[2]}%</div><br/>`;
      div.innerHTML += `<div class ='legendContent'><i style="background:${colorsCentralLegend[3]}"></i>+${legendLabel[3]}%</div><br/>`;
      div.innerHTML += `<div class ='legendContent'><i style="background:${colorsCentralLegend[4]}"></i>+${legendLabel[4]}%</div><br/>`;
      // div.innerHTML += `<div class ='legendContent'><i style="background:${colorsCentralLegend[5]}"></i>+${legendLabel[5]}%</div><br/>`;
      // div.innerHTML += `<div class ='legendContent'><i style="background:${colorsCentralLegend[6]}"></i>+${legendLabel[6]}%</div><br/>`;
      div.innerHTML += `<div class ='legendContent'><i class ='patternLegend'></i>No Data</div><br/>`;
      div.innerHTML += `<div class ='legendContent'><i class ='industryLegend'></i>Industry</div><br/>`;

      return div;
    };
    legendAllData.addTo(map);
  }
  useEffect(createDOM, [toggle_about, sliderValue, scenario]);

  const cazHook = () => {
    if (allModelLayer) {
      allModelLayer.remove();
    }
    allModelLayer = L.geoJSON(centralAZMap, {
      onEachFeature,
    }).addTo(map);
    if (industryLayer) {
      industryLayer.remove();
    }

    industryLayer = L.geoJSON(industryMap, {
      pointToLayer,
    }).addTo(map);
  }
  useEffect(cazHook, [toggle_about, sliderValue, entitlement_difference, scenario]);

  const handleMouseOperations = () => {
    if (map) {
      const Control = L.Control.extend({
        onAdd() {
          L.DomEvent.disableScrollPropagation(containerRef.current);
          containerRef.current.onmouseenter = (e) => map.dragging.disable();
          containerRef.current.onmouseleave = (e) => map.dragging.enable();
          return containerRef.current;
        },
      });
      const control = new Control({
        position: "bottomleft",
      });
      map.addControl(control);
      return () => {
        map.removeControl(control);
      };
    }
  }
  useEffect(handleMouseOperations, [map, toggle_about]);

  // renders the slider in a div component
  const renderSlider = () => {
    if (widget && !isMobile) {
      const container = containerRef.current;
      ReactDOM.render(widget, container);
    }
  }
  useEffect(renderSlider, [widget]);

  useEffect(() => {
    const container = containerRef.current;
    return () => {
      ReactDOM.unmountComponentAtNode(container);
    };
  }, [containerRef]);

  return (
    <Box className={isMobile ? classes.mapAreaResponsive : classes.mapArea}>
      <div
        className={isMobile ? classes.mapResponsive : classes.map}
        id="map"
      ></div>
    </Box>
  );
}

export default CentralArizonaMap;
